var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabPage tabPage4"},[_c('div',{staticClass:"content__bar"}),(_vm.tmp)?_c('TmpMessage'):_vm._e(),_c('LiveCamera',{attrs:{"dataList":_vm.cameraDataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }